import type { RequestClientAdminsBulkCreation } from '@fukuri-admins/apis/client/gen/model';
import { format } from 'date-fns';
import type { UserBulkCreationFormValues } from '../schema';

export const generateBulkCreationRequest = (
  data: UserBulkCreationFormValues
): RequestClientAdminsBulkCreation => ({
  file: data.file,
  selected_option: data.registrationType,
  scheduled_date: data.scheduledDate ? format(data.scheduledDate, 'yyyy-MM-dd') : null,
  scheduled_hour: data.scheduledTime ?? null,
});
